import * as types from './types';

const initialState = {
  policies: [],
  currentPolicy: null,
  loading: false,
  error: null,
  total: 0,
  page: 1,
  pageSize: 20,
};

const policiesReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Fetch Policies ──────────────────────────────────────────

    case types.FETCH_POLICIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_POLICIES_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: action.payload.results || action.payload,
        total: action.payload.count || action.payload.length,
      };

    case types.FETCH_POLICIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Fetch Single Policy ─────────────────────────────────────

    case types.FETCH_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        currentPolicy: action.payload,
      };

    case types.FETCH_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Create Policy ───────────────────────────────────────────

    case types.CREATE_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CREATE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: [action.payload, ...state.policies],
        total: state.total + 1,
      };

    case types.CREATE_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Update Policy ───────────────────────────────────────────

    case types.UPDATE_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.UPDATE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: state.policies.map((p) =>
          p.id === action.payload.id ? action.payload : p
        ),
        currentPolicy:
          state.currentPolicy?.id === action.payload.id
            ? action.payload
            : state.currentPolicy,
      };

    case types.UPDATE_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Delete Policy ───────────────────────────────────────────

    case types.DELETE_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DELETE_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: state.policies.filter((p) => p.id !== action.payload),
        total: state.total - 1,
      };

    case types.DELETE_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Utilities ───────────────────────────────────────────────

    case types.CLEAR_POLICY_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default policiesReducer;
